import React from "react";
import Button from "../../../common/components/Forms/Button/Button";
import cx from "classnames";
import styles from "./SettingNavigation.module.scss";
import Icon from "../../../common/components/Icon/Icon";

interface ISettingNavigation {
    className?: string;
    isDisabledCallToAction?: boolean;
    onClickCallToAction?: () => Promise<void> | void;
    // This will be the fallback if the 'return' param isn't provided
    onClickBack?: () => Promise<void> | void;
    isLoading?: boolean;
    gaAttributes?: {
        category?: string;
        action: string;
    };
    isEditing: boolean;
}

const SettingNavigation: React.FC<ISettingNavigation> = (props) => {
    const {
        isDisabledCallToAction,
        onClickCallToAction,
        onClickBack,
        className,
        isLoading,
        gaAttributes,
        isEditing
    } = props;

    const hideBackButton = !onClickBack || isLoading;


    return (
        <React.Fragment>
            <div className={styles["settings-navigation-spacer"]}>
                {/* The purpose of this element is to take up the space in the dom for spacing when fixed*/}
            </div>
            <div
                className={cx(
                    "layout-flex-column--centered",
                    styles["setting-navigation-wrapper"],
                    {
                        [className]: !!className
                    }
                )}>
                <div
                    className={cx(
                        "layout-flex-row--justify-evenly-spaced",
                        "flex-gap-l",
                        styles["setting-navigation-content"]
                    )}>
                    {onClickBack && (
                        <Button
                            className={cx(styles["setting-navigation-button"], {
                                ["layout-invisible"]: hideBackButton
                            })}
                            isDisabled={hideBackButton}
                            isSubmitting={isLoading}
                            onClick={onClickBack}
                            size="s"
                            component="button"
                            variant="box"
                            dataAttributes={
                                gaAttributes && {
                                    "data-ga_action": gaAttributes.action,
                                    "data-ga_category":
                                        gaAttributes.category || "build-step",
                                    "data-ga_label": isEditing
                                        ? "cancel-button"
                                        : "back-button"
                                }
                            }
                            width="fill">
                            {isEditing ? (
                                "Cancel"
                            ) : (
                                <React.Fragment>
                                    Back
                                </React.Fragment>
                            )}
                        </Button>
                    )}

                    {onClickCallToAction && (
                        <Button
                            component="button"
                            className={cx(styles["setting-navigation-button"]
                            )}
                            variant="calltoaction"
                            onClick={async () => {
                                onClickCallToAction && (await onClickCallToAction());
                            }}
                            size="s"
                            isSubmitting={isLoading}
                            isDisabled={isDisabledCallToAction}
                            dataAttributes={
                                gaAttributes && {
                                    "data-ga_action": gaAttributes.action,
                                    "data-ga_category": gaAttributes.category || "build-step",
                                    "data-ga_label": isEditing
                                        ? "apply-button"
                                        : "next-button"
                                }
                            }>
                            {isEditing ? (
                                "Apply Changes"
                            ) : (
                                <React.Fragment>
                                    Next
                                </React.Fragment>
                            )}
                        </Button>
                      )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default SettingNavigation;
